export const host = process.env.REACT_APP_BASE_URL;
export const mapsKey = process.env.REACT_APP_MAPS_KEY;

// export const host = process.env.NODE_ENV === 'production' ? '' : process.env.REACT_APP_BASE_URL;

// export const mapsKey =
//   process.env.NODE_ENV === 'production'
//     ? 'AIzaSyAlPXaP537liVKpvfReglnCbFb-9f0g9w8'
//     : 'AIzaSyDkKRY5r09a06PD_lMbLttP64CerxQEiR8';
